import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoginService } from '../service/login.service';
import { MenuService } from './menu.service';

export interface AuthUserObj {
	ownerId: string;
}

export class AuthServiceBase implements CanActivate {

	protected router: Router;
	protected menuService: MenuService;
	protected loginService: LoginService;
	protected translateService: TranslateService;

	constructor(
		router: Router,
		menuService: MenuService,
		loginService: LoginService,
		translateService: TranslateService
	) {
		this.router = router;
		this.menuService = menuService;
		this.loginService = loginService;
	}

	public isAuthorized(authObj: AuthUserObj): boolean {
		if (authObj) {
			if (authObj.ownerId) {
				if (!authObj.ownerId.localeCompare(this.loginService.getLoginId())) {
					return true;
				} else {
					return false;
				}	
			} else {
				return false;
			}
		} else {
			return true;
		}
	}

	async canActivate(activated: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		const session = this.loginService.getLoginId();

		if (session) {
			if (activated.routeConfig.path === 'main') {
				return true;
			} else {
				const menus = (await this.menuService.getByPath(activated.routeConfig.path).toPromise() as any[]);

				if (menus && menus.length > 0) {
					for (const menu of menus) {
						const roles = menu.roles.map((role: any) => role.userRole);
	
						for (const role of roles) {
							if (this.loginService.hasRole(role)) {
								return true;
							}
						}	
					}
					this.translateService.get('common.invalid.access-menu').subscribe((message: string) => {
						alert(message);
						this.router.navigate(['/main']);
					});

					return false;
				} else {
					return true;
				}
			}
		} else {
			this.translateService.get('common.invalid.access-user').subscribe((message: string) => {
				alert(message);
				this.router.navigate(['/member/login'], { queryParams: { returnUrl: state.url }});
			});
			return false;
		}
	}
}
